import { observable } from "mobx";
import { Type } from "class-transformer";
import VehicleRegistrationResponse from "./vehicleRegistrationResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargeResponse {
  /**
   * Price list item ID.
   */
  @observable
  priceListItemId!: string;

  @observable
  @Type(() => VehicleRegistrationResponse)
  vehicle!: VehicleRegistrationResponse;

  /**
   * Beginning date and time of charge validity.
   */
  @observable
  @Type(() => Date)
  validSince!: Date;

  /**
   * End date and time of charge validity.
   */
  @observable
  @Type(() => Date)
  validUntil!: Date;

  /**
   * Authentication code.
   */
  @observable
  authCode!: string;
}
